import { useSelector } from 'react-redux';
import {
  replaceDomainForCacheKey,
  useErrorOnNotOkFetchye,
} from '@americanexpress/fetchye-amex';
import { getBdaasAirportLoungesUrl } from '@/selectors/bdaasSelectors';
import { getOneCmsLocaleLoungesUrl } from '@/selectors/oneCmsSelectors';
import { useRouteParams } from '@/context/routeParamsContext';
import { getIsMarketWithTranslations } from '@/selectors/localeSelectors';
import { useMemberAccountToken } from '../memberHooks';

export const useBdaasAirportLounges = () => {
  // if (global.mock) {
  //   return {
  //     data: {
  //       body: global.mock.lounges,
  //     },
  //   };
  // }
  const routeParams = useRouteParams();
  const url = useSelector(getBdaasAirportLoungesUrl(routeParams));
  const { data: accountToken, isLoading: fetchyeMemberLoading } =
    useMemberAccountToken();

  const {
    data: lounges,
    isLoading: fetchyeLoungesLoading,
    error: fetchyeLoungesError,
  } = useErrorOnNotOkFetchye(
    url,
    {
      mapKeyToCacheKey: replaceDomainForCacheKey('bdaas'),
      credentials: 'include',
      defer: fetchyeMemberLoading,
      headers: {
        ...(accountToken && {
          account_token: accountToken,
        }),
      },
    },
    {
      reporting: {
        url,
        collectionMethod: 'useBdaasAirportLounges',
        moduleId: 'travel-lounge-finder-root',
      },
    }
  );

  return {
    data: lounges,
    error: fetchyeLoungesError,
    isLoading:
      fetchyeMemberLoading ||
      fetchyeLoungesLoading ||
      (!lounges && !fetchyeLoungesError),
  };
};
export const useOneCmsLocaleAirportLounges = () => {
  const isMarketWithTranslations = useSelector(getIsMarketWithTranslations);
  const url = useSelector(getOneCmsLocaleLoungesUrl);
  return useErrorOnNotOkFetchye(
    url,
    {
      defer: !isMarketWithTranslations,
      mapKeyToCacheKey: replaceDomainForCacheKey('oneCms'),
    },
    {
      reporting: {
        url,
        collectionMethod: 'useOneCmsLocaleAirportLounges',
        moduleId: 'travel-lounge-finder-root',
      },
    }
  );
};
